import englishContent from '../content/englishContent';

/**
 * Set these in `.env.local` (Create React App — must start with REACT_APP_).
 *
 * REACT_APP_GOOGLE_SCRIPT_URL — Web app URL …/exec (NOT the spreadsheet edit link). Overrides baked-in default.
 * REACT_APP_CONTACT_PHONE — digits only, country code, no + (e.g. 919876543210). Overrides `common.contactPhoneE164` in englishContent.js.
 * REACT_APP_CONTACT_EMAIL — optional; defaults to humproecosystem@gmail.com
 */

/** Used when env is unset (e.g. static hosting without env injection). Override with REACT_APP_GOOGLE_SCRIPT_URL. */
const DEFAULT_GOOGLE_CONTACT_SCRIPT_URL =
  'https://script.google.com/macros/s/AKfycbzIY6Bpg-kDPWogExhajZCJSc0DtSSuiqF1q_lpnImLPu7hqxyjnpzkrPiqedhpKkyb/exec';

const env = typeof process !== 'undefined' ? process.env : {};

export const GOOGLE_CONTACT_SCRIPT_URL =
  (env.REACT_APP_GOOGLE_SCRIPT_URL && String(env.REACT_APP_GOOGLE_SCRIPT_URL).trim()) ||
  DEFAULT_GOOGLE_CONTACT_SCRIPT_URL;

function digitsOnly(value) {
  return String(value || '').replace(/\D/g, '');
}

/** E.164 digits only. India: 10-digit mobiles get leading 91. */
function normalizePhoneE164(raw) {
  let d = digitsOnly(raw);
  if (!d) return '';
  if (d.length === 10 && /^[6-9]/.test(d)) {
    d = `91${d}`;
  }
  if (d.length >= 10 && d.length <= 15) {
    return d;
  }
  return '';
}

export const CONTACT_PHONE_E164 = normalizePhoneE164(
  env.REACT_APP_CONTACT_PHONE || englishContent.common.contactPhoneE164 || ''
);

export const CONTACT_EMAIL =
  (env.REACT_APP_CONTACT_EMAIL && String(env.REACT_APP_CONTACT_EMAIL).trim()) ||
  'humproecosystem@gmail.com';

/** True when Call / WhatsApp FABs can use tel: and wa.me (number is set and valid). */
export const hasPhoneQuickLinks = CONTACT_PHONE_E164.length > 0;
